import React, { useRef } from 'react';

const Anchor = ({ name }) => {
  const anchorRef = useRef();
  return <a name={name} ref={anchorRef}></a>;
};

export default Anchor;